import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../../core/services/language.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

export interface ModalMaintenanceData {
  message: string;
}
@Component({
  selector: 'app-modal-maintenance',
  templateUrl: './modal-maintenance.component.html',
  styleUrls: ['./modal-maintenance.component.scss'],
  imports: [SvgIconComponent, TranslateModule],
})
export class ModalMaintenanceComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalMaintenanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalMaintenanceData,
    public languageService: LanguageService
  ) {}

  ngOnInit(): void {}
}
